"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextualHelpPanel = ContextualHelpPanel;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grommet = require("grommet");
var _grommetIcons = require("grommet-icons");
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _i18n = _interopRequireDefault(require("../i18n"));
var _TopicContent = require("./TopicContent");
var _HelpTopics = require("./HelpTopics");
var _Loading = require("./Loading");
var _Feedback = require("./Feedback");
var _NoHelp = require("./NoHelp");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "backLabel", "viewAllUrl", "topics", "topic", "topicUrl", "onBack", "onClose", "onTopic", "onFeedback", "loading", "error", "testId", "onInternalLink", "onImageClick", "pin", "onPin"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var rotateAnimation = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-45deg);\n  }\n"])));
var animation = function animation() {
  return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", " 0.5s forwards;\n"])), rotateAnimation);
};
var activeStyle = function activeStyle(props) {
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), props.active && props.color && "\n  > path { fill: green !important;\n  ");
};
var StyledPin = (0, _styledComponents["default"])(_grommetIcons.Pin)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  animation: ", ";\n  ", "\n"])), animation, function (props) {
  return props.color && activeStyle(props);
});
function ContextualHelpPanel(_ref) {
  var title = _ref.title,
    backLabel = _ref.backLabel,
    viewAllUrl = _ref.viewAllUrl,
    topics = _ref.topics,
    topic = _ref.topic,
    topicUrl = _ref.topicUrl,
    onBack = _ref.onBack,
    onClose = _ref.onClose,
    onTopic = _ref.onTopic,
    onFeedback = _ref.onFeedback,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    error = _ref.error,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'contextual-help' : _ref$testId,
    onInternalLink = _ref.onInternalLink,
    onImageClick = _ref.onImageClick,
    _ref$pin = _ref.pin,
    pin = _ref$pin === void 0 ? false : _ref$pin,
    onPin = _ref.onPin,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var togglePin = function togglePin() {
    if (onPin) {
      onPin(!pin);
    }
  };
  var icon = pin ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPin, {
    color: "brand",
    active: pin
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommetIcons.Pin, {});
  var l10n = function l10n(key, def) {
    return _i18n["default"].exists(key) ? t(key) : def;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, _objectSpread(_objectSpread({
    width: "425px",
    overflow: "auto",
    flex: "grow",
    pad: "medium",
    gap: "small",
    "data-testid": testId
  }, rest), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Header, {
      fill: "horizontal",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
        align: "center",
        justify: "between",
        direction: "row",
        fill: "horizontal",
        children: [onBack ?
        /*#__PURE__*/
        // topic && topics ? (
        (0, _jsxRuntime.jsx)(_grommet.Anchor, {
          "data-testid": "".concat(testId, "--previous"),
          icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommetIcons.FormPrevious, {}),
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Text, {
            truncate: true,
            children: backLabel || t('back_label')
          }),
          weight: "normal",
          onClick: function onClick() {
            if (onBack) {
              onBack();
            }
          }
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Heading, {
          level: 2,
          size: "small",
          margin: "none",
          children: title || t('title')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_grommet.Box, {
          direction: "row",
          children: [onPin && topic && /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Tip, {
            content: pin ? l10n('unpin_tooltip', 'Unpin this topic open') : l10n('pin_tooltip', 'Pin this topic'),
            dropProps: {
              stretch: false
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Button, {
              active: pin,
              icon: icon,
              onClick: togglePin
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Button, {
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommetIcons.FormClose, {}),
            onClick: onClose
          })]
        })]
      })
    }), !onBack && !topic && !error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Box, {
      fill: "vertical",
      gap: "medium",
      justify: "between",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_HelpTopics.HelpTopics, {
        testId: "".concat(testId, "--topics"),
        topics: topics,
        onClick: onTopic,
        loading: loading,
        viewAllUrl: viewAllUrl
      })
    }), onBack && loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {
      testId: "".concat(testId, "--loading")
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TopicContent.TopicContent, {
        testId: "".concat(testId, "--topic"),
        content: topic,
        topicUrl: topicUrl,
        onInternalLink: onInternalLink,
        onImageClick: onImageClick
      }), !error && onFeedback && topic && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Feedback.Feedback, {
        onFeedback: onFeedback
      })]
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoHelp.NoHelp, {
      "data-testid": "".concat(testId, "--nohelp")
    })]
  }));
}
ContextualHelpPanel.displayName = 'ContextualHelpPanel';
ContextualHelpPanel.propTypes = {
  title: _propTypes["default"].string,
  backLabel: _propTypes["default"].string,
  topics: _propTypes["default"].string,
  topic: _propTypes["default"].string,
  topicUrl: _propTypes["default"].string,
  viewAllUrl: _propTypes["default"].string,
  onBack: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onInternalLink: _propTypes["default"].func,
  onImageClick: _propTypes["default"].func,
  onTopic: _propTypes["default"].func,
  onFeedback: _propTypes["default"].func,
  loading: _propTypes["default"].bool,
  pin: _propTypes["default"].bool,
  onPin: _propTypes["default"].func,
  error: _propTypes["default"].any,
  /**
   * It will be used for component reference to test.
   */
  testId: _propTypes["default"].string
};